<template>
    <div class="c-loading-container">
      <p class="message-box">読み込み中です...</p>
    </div>
</template>
  
<script setup lang="ts">
</script>